// ===========================================================================
//  GSAP animations — index
//  · Reveal del hero (titular palabra a palabra + acento).
//  · Scroll-scrubbing del hexágono del ecosistema (ensamblar/desarmar
//    atado al scroll) + entrada de la avispa.
//
//  Progressive enhancement: si GSAP no está cargado o el usuario pidió
//  menos movimiento, este módulo no hace nada y el contenido permanece
//  visible (las clases .gsap-on del CSS solo ocultan cuando GSAP gobierna).
// ===========================================================================
(function () {
    var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var active = false;          // ¿GSAP gobernando esta sesión?
    var triggers = [];           // ScrollTriggers creados (para limpiar en Turbo)
    var loops = [];              // tweens en bucle (para limpiar en Turbo)

    function gsapReady() {
        return typeof window.gsap !== 'undefined' && typeof window.ScrollTrigger !== 'undefined';
    }

    // Divide el titular del hero en palabras envueltas en <span class="hero-word">,
    // preservando el <span> del acento naranja.
    function splitHero(h1) {
        if (!h1 || h1.dataset.split === '1') return;
        var nodes = Array.prototype.slice.call(h1.childNodes);
        h1.dataset.split = '1';
        h1.innerHTML = '';
        nodes.forEach(function (node) {
            var isEl = node.nodeType === 1;
            var accentClass = isEl ? node.getAttribute('class') : '';
            var accentStyle = isEl ? node.getAttribute('style') : '';
            var text = node.textContent;
            var words = text.split(/(\s+)/); // conserva los espacios
            words.forEach(function (w) {
                if (w === '') return;
                if (/^\s+$/.test(w)) { h1.appendChild(document.createTextNode(' ')); return; }
                var span = document.createElement('span');
                span.className = 'hero-word' + (accentClass ? ' ' + accentClass : '');
                if (accentStyle) span.setAttribute('style', accentStyle);
                span.style.display = 'inline-block';
                span.style.willChange = 'transform, opacity';
                span.textContent = w;
                h1.appendChild(span);
            });
        });
    }

    function killAll() {
        triggers.forEach(function (t) { try { t.kill(); } catch (e) {} });
        loops.forEach(function (l) { try { l.kill(); } catch (e) {} });
        triggers = [];
        loops = [];
    }

    function run() {
        if (prefersReduced || !gsapReady()) return; // fallback: contenido visible
        active = true;
        document.documentElement.classList.add('gsap-on');
        window.gsap.registerPlugin(window.ScrollTrigger);
        var gsap = window.gsap;

        killAll(); // evita duplicados al re-entrar (Turbo)

        // --- HERO -----------------------------------------------------------
        var h1 = document.querySelector('.header-title h1');
        if (h1) {
            splitHero(h1);
            gsap.set(h1, { opacity: 1 });
            var words = h1.querySelectorAll('.hero-word');
            if (words.length) {
                gsap.fromTo(words,
                    { yPercent: 115, opacity: 0 },
                    {
                        yPercent: 0, opacity: 1, duration: 0.9, ease: 'power3.out',
                        stagger: 0.08, delay: 0.15
                    });
            }
        }

        // --- HEXÁGONO (scroll-scrub) ---------------------------------------
        var section = document.getElementById('hexagonos');
        var outer = document.getElementById('hexagon-outer');
        var middle = document.getElementById('hexagon-middle');
        var inner = document.getElementById('hexagon-inner');
        var hexes = [outer, middle, inner].filter(Boolean);
        var wasp = document.querySelectorAll('.wasp-hero-img');

        if (section && hexes.length) {
            // Centrado: top/left:50% (CSS) + translate(-50%,-50%) vía xPercent/yPercent.
            // x:0/y:0 anula el translate en px que GSAP hereda del CSS base
            // (evita el doble traslado y descentrado).
            gsap.set(hexes, { x: 0, y: 0, xPercent: -50, yPercent: -50, transformOrigin: '50% 50%' });
            gsap.set(outer, { scale: 0.6, opacity: 0 });
            gsap.set(middle, { scale: 0.6, opacity: 0 });
            gsap.set(inner, { scale: 0.6, opacity: 0 });
            if (wasp.length) gsap.set(wasp, { scale: 0.8, opacity: 0, transformOrigin: '50% 50%' });

            var tl = gsap.timeline({
                scrollTrigger: {
                    trigger: section,
                    start: 'top 78%',
                    end: 'top 28%',
                    scrub: 0.6
                }
            });
            tl.to(outer, { scale: 1, opacity: 1, ease: 'none' }, 0.0)
                .to(middle, { scale: 1, opacity: 1, ease: 'none' }, 0.18)
                .to(inner, { scale: 1, opacity: 1, ease: 'none' }, 0.36);
            if (wasp.length) {
                tl.to(wasp, { scale: 1, opacity: 1, ease: 'none' }, 0.5);
            }
            if (tl.scrollTrigger) triggers.push(tl.scrollTrigger);

            // Flotación sutil de la avispa (el único bucle).
            if (wasp.length) {
                var floatTween = gsap.to(wasp, {
                    y: -8, duration: 3.2, ease: 'sine.inOut',
                    repeat: -1, yoyo: true, delay: 1
                });
                loops.push(floatTween);
            }
        }

        window.ScrollTrigger.refresh();
    }

    // Disparadores: carga inicial + ciclo de vida de Turbo.
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', run);
    } else {
        run();
    }
    document.addEventListener('turbo:load', run);
    // Antes de cambiar de página, soltamos los triggers para no acumular.
    document.addEventListener('turbo:before-render', function () { if (active) killAll(); });
})();
